import React from "react";
import "./Banner.css";
import { useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate, useLocation } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";

const Banner = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const navigate = useNavigate();
  const location = useLocation();

  const handlePageClick = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        scrollToSection(id);
      }, 300);
    } else {
      scrollToSection(id);
    }
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#4a75f2",
        padding: "20px",
        color: "white",
        textAlign: "center",
      }}
    >
      <Box
        className="banner-content"
        sx={{ flexDirection: isMobile ? "column" : "row" }}
      >
        <h1>Let's Get Started! Contact us for a free estimate today.</h1>
        <button
          className="banner-button"
          style={{
            fontSize: "14px",
            textTransform: "uppercase",
            padding: "16px 30px 16px 30px",
            borderRadius: "5px",
            marginLeft: isMobile ? "0px" : "30px",
          }}
          onClick={() => handlePageClick("requestForm")}
        >
          GET A FREE ESTIMATE
        </button>
      </Box>
    </Box>
  );
};

export default Banner;
